// 主轨用两个已确认拐点确定，平行副轨用分散的价格触轨点验证。
// 信号日只使用前一交易日及更早的数据，避免回填未来拐点。
function detectChannel(rows, end, direction) {
    const start = Math.max(0, end - 59);
    const highs = [];
    const lows = [];
    for (let i = start + 2; i <= end - 2; i++) {
        const neighbours = rows.slice(i - 2, i + 3);
        if (neighbours.every((row, j) => j === 2 || row.high < rows[i].high)) highs.push(i);
        if (neighbours.every((row, j) => j === 2 || row.low > rows[i].low)) lows.push(i);
    }
    const primary = (direction < 0 ? highs : lows).slice(-6);
    for (let b = primary.length - 1; b > 0; b--) {
        for (let a = b - 1; a >= 0; a--) {
            if (fitsParallelEnvelope(rows, end, direction, primary[a], primary[b])) return true;
        }
    }
    if (highs.length < 2 || lows.length < 2) return false;
    // 枚举近期拐点组合，避免一个小波动抹掉已经形成的大通道。
    const recentHighs = highs.slice(-6);
    const recentLows = lows.slice(-6);
    for (let h = recentHighs.length - 1; h > 0; h--) {
        for (let a = h - 1; a >= 0; a--) {
            for (let l = recentLows.length - 1; l > 0; l--) {
                for (let b = l - 1; b >= 0; b--) {
                    if (fitsChannel(rows, end, direction, recentHighs[a], recentHighs[h], recentLows[b], recentLows[l])) return true;
                }
            }
        }
    }
    return false;
}

function fitsParallelEnvelope(rows, end, direction, first, second) {
    if (second - first < 3 || end - first < 10 || end - second > 20) return false;
    const primaryKey = direction < 0 ? 'high' : 'low';
    const secondaryKey = direction < 0 ? 'low' : 'high';
    const slope = (rows[second][primaryKey] - rows[first][primaryKey]) / (second - first);
    const scale = rows[end].close;
    if (slope * direction <= 0 || Math.abs(slope) * (end - first) < scale * 0.01) return false;
    const rangeStart = Math.max(1, end - 13);
    const ranges = rows.slice(rangeStart, end + 1).map((row, i) => {
        const previous = rows[rangeStart + i - 1].close;
        return Math.max(row.high - row.low, Math.abs(row.high - previous), Math.abs(row.low - previous));
    });
    const atr = ranges.reduce((sum, value) => sum + value, 0) / ranges.length;
    const tolerance = Math.max(scale * 0.003, atr * 0.6);
    const main = rows[first][primaryKey] - slope * first;
    const residuals = rows.slice(first, end + 1).map((row, i) => row[secondaryKey] - slope * (first + i));
    const secondary = direction < 0 ? Math.min(...residuals) : Math.max(...residuals);
    const upper = direction < 0 ? main : secondary;
    const lower = direction < 0 ? secondary : main;
    const width = upper - lower;
    if (width < Math.max(scale * 0.015, atr) || width > scale * 0.15) return false;
    const touches = residuals.map((value, i) => Math.abs(value - secondary) <= tolerance ? first + i : -1).filter(i => i >= 0);
    if (touches.length < 2 || touches[touches.length - 1] - touches[0] < 3 || end - touches[touches.length - 1] > 20) return false;
    let inside = 0;
    for (let i = first; i <= end; i++) {
        if (rows[i].high <= upper + slope * i + tolerance && rows[i].low >= lower + slope * i - tolerance) inside++;
    }
    if (inside / (end - first + 1) < 0.85) return false;
    const outside = i => rows[i].close > upper + slope * i + tolerance || rows[i].close < lower + slope * i - tolerance;
    return !(outside(end) && outside(end - 1));
}

function fitsChannel(rows, end, direction, h1, h2, l1, l2) {
    if (h2 - h1 < 3 || l2 - l1 < 3) return false;
    const first = Math.min(h1, l1);
    const last = Math.max(h2, l2);
    if (h1 >= l2 || l1 >= h2) return false;
    if (last - first < 10 || end - Math.min(h2, l2) > 20) return false;
    const highSlope = (rows[h2].high - rows[h1].high) / (h2 - h1);
    const lowSlope = (rows[l2].low - rows[l1].low) / (l2 - l1);
    if (highSlope * direction <= 0 || lowSlope * direction <= 0) return false;
    const slope = direction < 0 ? highSlope : lowSlope;
    const scale = rows[end].close;
    if (Math.abs(slope) * (last - first) < scale * 0.01) return false;
    const rangeStart = Math.max(1, end - 13);
    const ranges = rows.slice(rangeStart, end + 1).map((row, i) => {
        const previous = rows[rangeStart + i - 1].close;
        return Math.max(row.high - row.low, Math.abs(row.high - previous), Math.abs(row.low - previous));
    });
    const atr = ranges.reduce((sum, value) => sum + value, 0) / ranges.length;
    const tolerance = Math.max(scale * 0.003, atr * 0.6);
    if (Math.abs(highSlope - lowSlope) * Math.min(h2 - h1, l2 - l1) > tolerance) return false;
    const upper = rows[h1].high - slope * h1;
    const lower = rows[l1].low - slope * l1;
    const width = upper - lower;
    if (width < Math.max(scale * 0.015, atr) || width > scale * 0.15) return false;
    let inside = 0;
    for (let i = first; i <= end; i++) {
        if (rows[i].high <= upper + slope * i + tolerance && rows[i].low >= lower + slope * i - tolerance) inside++;
    }
    if (inside / (end - first + 1) < 0.85) return false;
    const outside = i => rows[i].close > upper + slope * i + tolerance || rows[i].close < lower + slope * i - tolerance;
    return !(outside(end) && outside(end - 1));
}

export function buildMarketTrendDetails(rawRows, dates) {
    const rows = [...new Map(rawRows.map(row => [String(row.date1 || row.date || '').slice(0, 10), row])).values()]
        .map(row => ({ date: String(row.date1 || row.date || '').slice(0, 10), close: Number(row.p_close), high: Number(row.p_high), low: Number(row.p_low) }))
        .filter(row => row.date && [row.close, row.high, row.low].every(value => Number.isFinite(value) && value > 0))
        .sort((a, b) => a.date.localeCompare(b.date));
    let ema12 = rows.length ? rows[0].close : 0;
    let ema26 = ema12;
    const diff = rows.map((row, index) => {
        if (index > 0) {
            ema12 += (row.close - ema12) * 2 / 13;
            ema26 += (row.close - ema26) * 2 / 27;
        }
        return ema12 - ema26;
    });
    let cursor = -1;
    const result = {};
    [...dates].sort().forEach(date => {
        while (cursor + 1 < rows.length && rows[cursor + 1].date < date) cursor++;
        const down = cursor >= 24 && detectChannel(rows, cursor, -1);
        const up = cursor >= 24 && detectChannel(rows, cursor, 1);
        // EMA 预热130个交易日；最近三个DIFF全部为负且逐日下降。
        const ready = cursor >= 129;
        const macdConfirmed = ready && diff[cursor - 2] < 0 && diff[cursor - 1] < 0 && diff[cursor] < 0
            && diff[cursor] < diff[cursor - 1] && diff[cursor - 1] < diff[cursor - 2];
        const channel = cursor < 24 ? 'unknown' : down && !up ? 'down' : up && !down ? 'up' : 'range';
        result[date] = {
            channel,
            trend: !ready ? 'unknown' : channel === 'down' && !macdConfirmed ? 'range' : channel,
            macdConfirmed,
            diff: ready ? diff[cursor] : null,
            previousDiff: ready ? diff[cursor - 1] : null,
            earlierDiff: ready ? diff[cursor - 2] : null,
            asOf: cursor >= 0 ? rows[cursor].date : null
        };
    });
    return result;
}

export function buildMarketTrend(rawRows, dates) {
    const details = buildMarketTrendDetails(rawRows, dates);
    return Object.fromEntries(Object.entries(details).map(([date, state]) => [date, state.trend]));
}
